export default "__VITE_ASSET__BZm0PdDa__"